import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Chip } from '#src/atoms/ui/Chip/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

import type { CardSetChip_cardSet } from './__generated__/index.graphql.ts';

const StyledChip = styled(Chip)`
  background: linear-gradient(270deg, #2d0033 0%, rgba(45, 0, 51, 0) 100%);
  color: var(--c-set-surface-primary-text);
  border: 1px solid var(--c-set-surface-primary-text);
  backdrop-filter: blur(16px);
`;
type Props = {
  cardSet: Nullable<CardSetChip_cardSet>;
};

export const CardSetChip = ({ cardSet }: Props) => {
  if (!cardSet) {
    return null;
  }
  return (
    <StyledChip size="small" color="transparent">
      <FormattedMessage
        {...glossary.setEdition}
        values={{
          set: cardSet.name,
        }}
      />
    </StyledChip>
  );
};

CardSetChip.fragments = {
  cardSet: gql`
    fragment CardSetChip_cardSet on CardSet {
      slug
      name
    }
  ` as TypedDocumentNode<CardSetChip_cardSet>,
};
